"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AttachmentList;

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _AttachmentRounded2 = _interopRequireDefault(require("@material-ui/icons/AttachmentRounded"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _styles = require("@material-ui/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var _arrayMove = _interopRequireDefault(require("../utils/arrayMove"));

var _Button = _interopRequireDefault(require("./Button"));

var _excluded = ["listRef"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

AttachmentList.propTypes = {
  attachments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    url: _propTypes["default"].string,
    fileName: _propTypes["default"].string
  })),
  onDelete: _propTypes["default"].func,
  onUpdate: _propTypes["default"].func,
  onClickAttachFile: _propTypes["default"].func
};
var ListContainer = (0, _styles.withStyles)(function () {
  return {
    root: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridGap: 16
    },
    "@media (max-width: 960px)": {
      root: {
        gridTemplateColumns: "1fr 1fr"
      }
    }
  };
})(_Box2["default"]);
var ItemContainer = (0, _styles.withStyles)(function () {
  return {
    root: {
      width: "100%",
      zIndex: 5000
    }
  };
})(_Box2["default"]);

function AttachmentList(_ref) {
  var attachments = _ref.attachments,
      onUpdate = _ref.onUpdate,
      onClickAttachFile = _ref.onClickAttachFile;
  var ItemContainerSortable = (0, _reactSortableHoc.SortableElement)(function (props) {
    return /*#__PURE__*/_react["default"].createElement(ItemContainer, props);
  });
  var ListContainerSortable = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
    var listRef = _ref2.listRef,
        props = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/_react["default"].createElement(ListContainer, _extends({
      ref: listRef
    }, props));
  });

  var onSortEnd = function onSortEnd(_ref3) {
    var oldIndex = _ref3.oldIndex,
        newIndex = _ref3.newIndex;
    onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate((0, _arrayMove["default"])(attachments, oldIndex, newIndex));
  };

  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], null, onClickAttachFile && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mb: 1
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    startIcon: /*#__PURE__*/_react["default"].createElement(_AttachmentRounded2["default"], {
      fontSize: "small"
    }),
    onClick: onClickAttachFile,
    variant: "contained",
    size: "small",
    style: {
      padding: "1px 10px"
    }
  }, "Attach file")), /*#__PURE__*/_react["default"].createElement(ListContainerSortable, {
    axis: "xy",
    onSortEnd: onSortEnd
  }, attachments === null || attachments === void 0 ? void 0 : attachments.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(ItemContainerSortable, {
      index: index,
      key: item.fileName
    }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "2px solid #f2f2f2",
        borderRadius: 6,
        height: 200,
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: 4
      }
    }, /*#__PURE__*/_react["default"].createElement("img", {
      style: {
        maxWidth: "100%",
        maxHeight: "100%"
      },
      alt: item.fileName,
      src: item.url
    })), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      jus: true
    }, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, item.fileName.length > 30 ? item.fileName.slice(0, 17).trim() + "..." : item.fileName)));
  })));
}